import { BID_STATE } from '../../services/bid'
import { COLOR_STATE_TAG } from './constants'
import { AUCTION_STATE } from '../../services/auction/constants'

export function getBidTagData(bidState) {
  switch (bidState) {
    case BID_STATE.WINNING:
      return {
        text: 'winning',
        iconName: 'finished-event',
        colorState: COLOR_STATE_TAG.WIN
      }
    case BID_STATE.OUTBID:
      return {
        text: 'outbid',
        iconName: 'warning',
        colorState: COLOR_STATE_TAG.OUTBID
      }
    default:
      return
  }
}

export function getAuctionData(auctionState) {
  switch (auctionState) {
    case AUCTION_STATE.LIVE:
      return {
        text: 'live',
        iconName: 'live-event',
        colorState: COLOR_STATE_TAG.LIVE
      }
    case AUCTION_STATE.PENDING:
      return {
        text: 'pending',
        iconName: 'warning',
        colorState: COLOR_STATE_TAG.LIVE
      }
    case AUCTION_STATE.CLOSED:
      return {
        text: 'closed',
        iconName: 'clock2',
        colorState: COLOR_STATE_TAG.CLOSED
      }
    case AUCTION_STATE.DRAFT:
      return {
        text: 'draft',
        colorState: COLOR_STATE_TAG.CLOSED
      }
    default:
      return
  }
}



// WEBPACK FOOTER //
// ./src/ui/tags/utils.js